import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PersonalizedRecommendations = ({ recommendations, onAddToCart }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Recommended for You</h2>
        <Link to="/recommendations">
          <Button variant="outline" size="sm" iconName="ArrowRight" iconPosition="right">
            View All
          </Button>
        </Link>
      </div>
      
      {recommendations.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Sparkles" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground mb-4">No recommendations available</p>
          <p className="text-sm text-muted-foreground">Shop more to get personalized recommendations</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {recommendations.map((product) => (
            <div key={product.id} className="bg-background border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-shadow">
              <div className="relative mb-3">
                <div className="w-full h-40 bg-muted rounded-lg overflow-hidden">
                  <Image
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                {product.discount && (
                  <span className="absolute top-2 left-2 bg-error text-error-foreground text-xs font-medium px-2 py-1 rounded">
                    -{product.discount}%
                  </span>
                )}
                <div className="absolute top-2 right-2 bg-accent text-accent-foreground text-xs font-medium px-2 py-1 rounded">
                  {product.reason}
                </div>
              </div>
              
              <div className="mb-3">
                <h3 className="font-medium text-foreground mb-1 line-clamp-2">{product.name}</h3>
                <p className="text-sm text-muted-foreground mb-2">{product.category}</p>
                
                <div className="flex items-center space-x-2 mb-2">
                  <span className="font-semibold text-foreground">${product.price.toFixed(2)}</span>
                  {product.originalPrice && (
                    <span className="text-sm text-muted-foreground line-through">
                      ${product.originalPrice.toFixed(2)}
                    </span>
                  )}
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <Icon
                          key={i}
                          name="Star"
                          size={12}
                          className={i < Math.floor(product.rating) ? 'text-yellow-400 fill-current' : 'text-muted-foreground'}
                        />
                      ))}
                    </div>
                    <span className="text-xs text-muted-foreground ml-1">({product.reviews})</span>
                  </div>
                  <span className="text-xs text-success font-medium">{product.confidence}% match</span>
                </div>
              </div>
              
              <div className="flex space-x-2">
                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  iconName="Eye"
                  iconPosition="left"
                >
                  View
                </Button>
                <Button
                  variant="default"
                  size="sm"
                  fullWidth
                  iconName="ShoppingCart"
                  iconPosition="left"
                  onClick={() => onAddToCart(product)}
                >
                  Add to Cart
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PersonalizedRecommendations;